var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopySuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4338_2071)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4338_2071",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 18.3334C11.0946 18.3348 12.1787 18.1199 13.1899 17.701C14.2012 17.2821 15.1196 16.6675 15.8926 15.8925C16.6676 15.1196 17.2822 14.2011 17.7011 13.1899C18.1199 12.1786 18.3348 11.0946 18.3334 10C18.3348 8.90548 18.1199 7.82144 17.701 6.81021C17.2821 5.79897 16.6676 4.88049 15.8926 4.10753C15.1196 3.33254 14.2012 2.71794 13.1899 2.29906C12.1787 1.88018 11.0946 1.66528 10.0001 1.66669C8.90554 1.6653 7.8215 1.88022 6.81027 2.29909C5.79904 2.71797 4.88055 3.33256 4.10759 4.10753C3.33262 4.88049 2.71804 5.79897 2.29916 6.81021C1.88028 7.82144 1.66536 8.90548 1.66676 10C1.66534 11.0946 1.88024 12.1786 2.29912 13.1899C2.718 14.2011 3.3326 15.1196 4.10759 15.8925C4.88055 16.6675 5.79904 17.2821 6.81027 17.701C7.8215 18.1198 8.90554 18.3348 10.0001 18.3334Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 10L9.16675 12.5L14.1667 7.5",
    stroke: "black",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4338_2071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4338_2071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySuccess);
export default __webpack_public_path__ + "static/media/copy_success.24f08815a51d495377955ff9396389ba.svg";
export { ForwardRef as ReactComponent };